var React = require('react');
var ReactDOM = require('react-dom');

// Components
var PromptModule = require('../../components/PromptModule/PromptModule');
var { getLoginStatus } = require('Logon/Logon');

// Style
require('./RestrictedContent.scss');

// Assets
var spursLogo = require('images/spurs_logo.svg');
var padlock = require('images/padlock.png');

class RestrictedContent extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false
		};
	}

	restrictedClick = e => {
		e.preventDefault();
		e.stopPropagation();
		this.handleOpen();
		ReactDOM.render(
			<PromptModule
				link={this.loginUrl}
				promptTitle="Sign in required"
				promptText="To view this content you need to sign in or register your free account"
				popUpHandler={this.handleOpen}
			/>,
			document.getElementById('SpursPrompt')
		);
	};

	componentDidMount() {
		getLoginStatus()
			.then(result => {
				this.setState({ isLoggedIn: result.isLoggedIn });
			})
			.catch(err => {
				console.error('Login status fetch failed:', err);
			});

		const el = ReactDOM.findDOMNode(this.restricted);
		if (el) {
			el.addEventListener('click', this.restrictedClick);
		}
	}
	

	handleOpen = e => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	render() {
		return !this.props.hasAccess ? (
			<div className={"Restricted " + (this.props.className ? "Restricted--" + this.props.className : "")} ref={restricted => this.restricted = restricted} aria-haspopup aria-expanded={this.state.isOpen}>
				<p className="Restricted__text"><span className="bold">Sign in</span> or <span className="bold">Register for free</span> to view</p>
				<div className="Restricted__ribbon">
					<div className="Restricted__square">
						<img className="spurs-logo" src={spursLogo} alt="" />
						<div className="Restricted__lock">
							<img className="padlock" src={padlock} alt="" />
						</div>
					</div>
					<div className="Restricted__triangle"></div>
				</div>
				{this.props.children}
			</div>
		) : (
				this.props.children
			)
	}
}

module.exports = RestrictedContent;


// WEBPACK FOOTER //
// ./src/common/RestrictedContent/RestrictedContent.js